import LocatorOffline from "./LocatorOffline.js";
import LocatorUnactivated from "./LocatorUnactivated.js";
import LocatorPairingValidationAction from "./LocatorPairingValidationAction.js";
import LocatorPairingSelectionRenderer from "./LocatorPairingSelectionRenderer.js";
function install(molten) {
  // Register validation views
  molten.addPlugin('WizardStep', {
    type: 'recovr.LocatorOffline',
    content: LocatorOffline
  });
  molten.addPlugin('WizardStep', {
    type: 'recovr.LocatorUnactivated',
    content: LocatorUnactivated
  });
  // Register the pairing validation action
  molten.addPlugin('WizardAction', LocatorPairingValidationAction);
  molten.addPlugin('PairingSelectionRenderer', LocatorPairingSelectionRenderer);
}
export default {
  install
};